{
  "PAGINATION_FOOTER": {
    "SHOWING": "Showing {startItem} - {endItem} of {totalItems} items",
    "CURRENT_PAGE_INFO": "{currentPage} of {totalPages} pages"
  },
  "COMBOBOX": {
    "PLACEHOLDER": "Select an option...",
    "EMPTY_SEARCH_RESULTS": "No items found for the search term `{searchTerm}`",
    "EMPTY_STATE": "Ingen resultater fundet.",
    "SEARCH_PLACEHOLDER": "Search...",
    "MORE": "+{count} more"
  },
  "DROPDOWN_MENU": {
    "SEARCH_PLACEHOLDER": "Search...",
    "EMPTY_STATE": "Ingen resultater fundet.",
    "SEARCHING": "Søger..."
  },
  "DIALOG": {
    "BUTTONS": {
      "CANCEL": "Annuller",
      "CONFIRM": "Bekræft"
    }
  },
  "PHONE_INPUT": {
    "SEARCH_PLACEHOLDER": "Søg land",
    "ERROR": "Phone number should be empty or in E.164 format",
    "DIAL_CODE_ERROR": "Please select a dial code from the list"
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Forfatteren er ikke tilgængelig"
    }
  },
  "BREADCRUMB": {
    "ARIA_LABEL": "Breadcrumb"
  },
  "SWITCH": {
    "TOGGLE": "Toggle switch"
  },
  "LABEL": {
    "TAG_BUTTON": "tag"
  },
  "FEATURE_SPOTLIGHT": {
    "LEARN_MORE": "Lær mere",
    "WATCH_VIDEO": "Watch video"
  },
  "DURATION_INPUT": {
    "MINUTES": "Minutter",
    "HOURS": "Timer",
    "DAYS": "Dage",
    "PLACEHOLDER": "Angiv varighed"
  }
}
